/**
 * Org ABDM HIU ID settings API.
 *
 * Per-org setting:
 *   - abdm_hiu_id: the Health Information User ID this org is registered
 *     under with ABDM/NHA — used when this org REQUESTS a patient's records
 *     from other facilities (M3), as distinct from its HIP ID (used when
 *     publishing its own records, M2 — see hipSettingsApi.js). Empty string
 *     (default) means unset — the live resolver falls back to the sandbox
 *     ABDM_HIU_ID env var.
 *
 * Backend: GET / PUT /api/organisation/settings/hiu
 * PUT is a partial update — an omitted field keeps its current value.
 */
import apiClient from './apiClient';

export const getHiuSettings = async () => {
  const res = await apiClient.get('/api/organisation/settings/hiu');
  return res.data;
};

export const updateHiuSettings = async (hiuId) => {
  const res = await apiClient.put('/api/organisation/settings/hiu', { abdm_hiu_id: hiuId });
  return res.data;
};
